import { Container } from '@ui/container'
import Iframe from '@ui/iframe'
import React, { type FC } from 'react'

const VerifiedReviews: FC = () => (
  <Container>
    <Iframe
      className="h-[430px] laptop:h-[260px]"
      id="AV_widget_iframe"
      title="avis vérifiés"
      url="//cl.avis-verifies.com/fr/cache/6/c/c/6ccce3ac-4a8f-f8a4-f90f-d9e90ef420b0/widget4/6ccce3ac-4a8f-f8a4-f90f-d9e90ef420b0horizontal_index.html"
    />
  </Container>
)

export default VerifiedReviews
